import React, { Component } from "react";
import GalleryMaisonary from "../components/galleryMaisonary";
import { photographers } from "../data/photographers";

var brakePoints = [350, 500, 750];
var images = [];

photographers.forEach(name => {
  var photographerId = name
    .toLowerCase()
    .replace(" ", "_")
    .replace("-", "_");

  images.push({
    src: "./images/photographers/" + photographerId + "/cover.jpg",
    title: name,
    photographerId: photographerId
  });
});

class Galleries extends Component {
  render() {
    return (
      <div className="container">
        <h1>Galleries</h1>
        <GalleryMaisonary images={images} brakePoints={brakePoints} />
      </div>
    );
  }
}

export default Galleries;



// WEBPACK FOOTER //
// ./src/pages/galleries.jsx